var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGreen24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 24C13.8333 18.5522 17.9049 14.0569 23.1667 13.3998L23.1667 34.6002C17.9049 33.9431 13.8333 29.4478 13.8333 24ZM25.8333 13.3998C31.0951 14.0569 35.1667 18.5522 35.1667 24C35.1667 29.4478 31.0951 33.9431 25.8333 34.6002V13.3998Z",
    fill: "#9FE870"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 2.6753V10.7123C16.4289 11.3823 11.1667 17.0757 11.1667 24C11.1667 30.9243 16.4289 36.6177 23.1667 37.2877V45.3247V48C10.532 47.3071 0.5 36.8269 0.5 24C0.5 11.1731 10.532 0.692894 23.1667 0V2.6753Z",
    fill: "#9FE870"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 10.7123V2.6753V0C38.468 0.692894 48.5 11.1731 48.5 24C48.5 36.8269 38.468 47.3071 25.8333 48V45.3247V37.2877C32.5711 36.6177 37.8333 30.9243 37.8333 24C37.8333 17.0757 32.5711 11.3823 25.8333 10.7123Z",
    fill: "#9FE870"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen24);
export default __webpack_public_path__ + "static/media/logo-green-24.c91da2b1ca93a7ebd268545e9c7ef350.svg";
export { ForwardRef as ReactComponent };